<template>
  <div id="commonUpload" :class="{ 'hide-upload-btn': isHideUploadBtn }">
    <!--  :data="uploadData" -->
    <el-upload
      ref="elUpload"
      action
      :http-request="onUpload"
      list-type="picture-card"
      :limit="limit"
      :disabled="disabled"
      :accept="accept"
      :file-list="fileList"
      :on-change="onChange"
      :on-remove="onRemove"
      :on-progress="onProgress"
      :before-upload="onBeforeUpload"
      class="upload-box"
    >
      <div class="upload-box" v-if="fileList.length < limit">
        <img src="../../assets/image/upload/6.png" class="upload-icon" />
        <!-- <span>点击拍照</span> -->
      </div>
      <div slot="file" slot-scope="{ file }" class="upload-container">
        <el-progress
          v-if="file.showPercentage"
          :show-text="false"
          type="circle"
          :percentage="file.percentage"
        ></el-progress>
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <div class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview">
            <i class="el-icon-zoom-in" @click="handlePictureCardPreview(file)"></i>
          </span>
          <span v-if="!file.showPercentage && !isPreview" class="el-upload-list__item-delete">
            <i class="el-icon-delete" @click="onRemove(file)"></i>
          </span>
        </div>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body title="图片预览" top="3%">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
// import { photoPolicyPutUpload } from '@/api/photoConfig.js';
import { uploadImg, policyPutUpload } from '../../services/api/brandList.js';
export default {
  name: 'commonUpload',
  components: {},
  filters: {},
  mixins: [],
  model: {
    prop: 'urlList',
    event: 'change'
  },
  props: {
    /**
     * 上传函数
     */
    uploadFuc: {
      type: Function,
      default: uploadImg
    },
    urlList: {
      type: Array,
      default: () => []
    },
    sizeLimit: {
      type: [Number, null],
      default: null
    },
    limit: {
      type: Number,
      default: 3
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: '*/*'
    },
    subData: {
      //需要提交的数据
      type: Object,
      default: () => {}
    },
    fileKey: {
      type: String,
      default: 'file'
    }
  },
  data() {
    return {
      actionUrl: '',
      uploadData: {
        name: '',
        'x-oss-object-acl': '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '',
        callback: '',
        signature: ''
      },
      fileList: [],
      uploadFiles: [],
      dialogVisible: false,
      dialogImageUrl: '',
      loading: false
    };
  },
  computed: {
    isHideUploadBtn() {
      return this.isPreview || this.fileList.length >= this.limit;
    }
  },
  watch: {
    urlList: {
      handler(value) {
        this.fileList = value;
      },
      immediate: true
    },
    fileList: {
      immediate: true,
      handler(val) {
        this.changeAdd();
      }
    }
  },
  created() {
    this.fileList = this.urlList;
  },
  mounted() {
    this.changeAdd();
  },
  beforeDestroy() {},
  methods: {
    /**
     * 获取POST上传授权
     * @desc 因为后台使用阿里云oss, 所以需要在获取授权中拿到上传文件的地址
     */
    // policyPostUpload() {
    //   console.log(11111111111111111111)
    //   return
    // },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onBeforeUpload(file) {
      console.log('file', file);
      const { type, size } = file;
      if (!this.accept.includes(type)) {
        this.$message.warning('文件格式不正确');
        return false;
      }
      if (this.sizeLimit && size > this.sizeLimit) {
        this.$message.warning('图片大小超出限制');
        return false;
      }
      // this.policyPostUpload();
      return true;
    },
    onUpload(data) {
      const { file } = data;
      const formData = new FormData();
      data.onProgress({ percent: 0 });
      policyPutUpload({
        realName: '1',
        authority: 'public-read'
      }).then(resData => {
        const { host, dir, policy, accessid, callback, signature } = resData.data;

        //获取文件后缀名
        const fileName = Date.now();
        formData.append('name', fileName);
        formData.append('x-oss-object-acl', 'public-read');
        formData.append('key', dir + fileName);
        formData.append('policy', policy);
        formData.append('OSSAccessKeyId', accessid);
        formData.append('success_action_status', '200');
        formData.append('callback', callback);
        formData.append('signature', signature);
        formData.append('file', file);
        this.uploadFuc(host, formData)
          .then(res => {
            console.log(res)
            const { url, id } = res.data;
            file.imageId = id;
            data.onProgress({ percent: 100 });
            data.onSuccess(url, file);
          })
          .catch(() => {
            this.onRemove(file);
            this.$message.error('上传失败');
            this.loading = false;
          });
      });
    },
    onRemove(file) {
      file.status = 'delete';
      this.onChange(file);
    },
    onProgress(event, file) {
      file.status = 'loading';
      this.onChange(file);
    },
    onChange(file) {
      const { status } = file;
      if (status === 'ready') {
        this.fileList.push(file);
      }
      let index = this.fileList.findIndex(item => item.uid === file.uid);
      if (status === 'loading') {
        file.showPercentage = true;
        this.loading = true;
      }
      if (status === 'delete') {
        this.fileList.splice(index, 1);
        this.$emit('change', this.fileList);
      }
      if (status === 'success') {
        const { response } = file;
        file.url = response;
        this.loading = false;
        setTimeout(() => {
          index = this.fileList.findIndex(item => item.uid === file.uid);
          this.$delete(this.fileList[index], 'showPercentage');
          this.$set(this.fileList[index], 'showPercentage', false);
          this.$emit('change', this.fileList);
        }, 500);
      }
      this.changeAdd();
    },
    changeAdd() {
      const staticClass = 'el-upload el-upload--picture-card';
      const lastChild =
        this.$refs.elUpload &&
        this.$refs.elUpload.$children &&
        this.$refs.elUpload.$children.length > 0 &&
        this.$refs.elUpload.$children[this.$refs.elUpload.$children.length - 1];
      if (lastChild) {
        if (this.fileList.length === this.limit || this.disabled || this.isPreview) {
          lastChild.$el.className = `${staticClass} displayNone`;
        } else {
          lastChild.$el.className = staticClass;
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
/deep/ .displayNone {
  display: none !important;
}
// #commonUpload {
//   ::v-deep {
//     .el-upload-list__item {
//       width: 120px;
//       height: 120px;
//       line-height: 122px;
//       transition: none;
//     }
//     .el-upload-list__item,
//     .el-upload--picture-card {
//       width: 120px;
//       height: 120px;
//       line-height: 122px;
//     }

//     .el-progress {
//       width: 100px;
//     }
//   }
// }

/deep/.el-upload--picture-card {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 100%;
  height: 100%;
  border: none;
}

// .hide-upload-btn {
//   ::v-deep .el-upload--picture-card {
//     display: none;
//   }
// }

.upload-box {
  width: 320px;
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #f7f7f7;
  border-radius: 16px;
  overflow: hidden;

  span {
    color: #999;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 16px;
  }

  .upload-icon {
    width: 80px;
    height: 80px;
  }
}
</style>
